import { DriverTableRoute } from "@types_def/models/driver.types";

type GetDriverTableRouteAttributes = Array<{
  key: DriverTableRoute;
  title: string;
  confirmationStatus?: boolean;
}>;

export const driverTableRouteAttributes: GetDriverTableRouteAttributes = [
  {
    key: DriverTableRoute.ACCEPTED_REQUESTS,
    title: "",
    confirmationStatus: true,
  },
  {
    key: DriverTableRoute.WAITING_REQUESTS,
    title: "",
    confirmationStatus: false,
  },
  {
    key: DriverTableRoute.REFUSED_REQUESTS,
    title: "",
    confirmationStatus: false,
  },
  {
    key: DriverTableRoute.DISABLED_DRIVERS,
    title: "",
    confirmationStatus: false,
  },
];
